import { Lottie } from '@crello/react-lottie';

import { RealObject } from '@tb-core/types';

export type AnimatedContentPlayingStates = 'paused' | 'playing' | 'stopped';

export interface AnimatedContentProps {
    className?: string;
    height?: string;
    loop?: boolean;
    playingState?: AnimatedContentPlayingStates;
    // @todo: fix later so that Visitor prioritization and this component works properly
    src: RealObject | string;
    width?: string;
}

const AnimatedContent = ({
    className,
    loop = false,
    playingState = 'playing',
    src,
    ...props
}: AnimatedContentProps) => (
    <Lottie
        className={className}
        config={{
            loop,
            // @todo make sure this is using the path prop instead of animationData to
            // correctly pull data from contenftul
            animationData: src
        }}
        playingState={playingState}
        {...props}
    />
);

export default AnimatedContent;
